export default "__VITE_ASSET__d7bec003__"